import React, { useEffect, useCallback, useState} from 'react';
import ChordEffectChooser from './ChordEffectChooser.js';
import ScaleChooser from './ScaleChooser.js';
import ChordChooser from './ChordChooser.js';
import {connect} from 'react-redux';
import RackComponent from "components/effects/rack/RackComponent.js";

import '../../../GenerativeChords.scss';

const GenerativeChordsComponent = ({effect}) => { 
    let {track, chordProgression} = effect;

    return (
        <div className="generative-chords">
          <div>
            <ScaleChooser effect={effect}/>
            <RackComponent
              effect={chordProgression}
              track={track}
              sequencerEngine={track.sequencerEngine}/>
            <ChordEffectChooser effect={effect}/>
          </div>
          <ChordChooser effect={effect}/>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GenerativeChordsComponent);
